var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52248 9.29766C7.88922 5.99704 10.6791 3.5 14 3.5V3.5C17.3209 3.5 20.1108 5.99704 20.4775 9.29765L20.7713 11.9416C20.775 11.9753 20.7769 11.9921 20.7788 12.0088C20.9293 13.3198 21.356 14.5839 22.0308 15.7179C22.0394 15.7323 22.0481 15.7469 22.0656 15.7759L22.7399 16.8999C23.3519 17.9199 23.6579 18.4299 23.5919 18.8485C23.5479 19.1271 23.4045 19.3803 23.1883 19.5613C22.8633 19.8333 22.2685 19.8333 21.0791 19.8333H6.92094C5.73146 19.8333 5.13673 19.8333 4.81173 19.5613C4.59547 19.3803 4.4521 19.1271 4.40815 18.8485C4.34209 18.4299 4.64808 17.9199 5.26006 16.8999L5.93443 15.7759C5.95188 15.7469 5.9606 15.7323 5.96918 15.7179C6.64403 14.5839 7.07075 13.3198 7.22118 12.0088C7.2231 11.9921 7.22497 11.9753 7.22871 11.9416L7.52248 9.29766Z",
    stroke: "#1C1D40",
    strokeWidth: 2.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6193 20.6088C10.8187 21.7251 11.2581 22.7116 11.8693 23.4151C12.4806 24.1187 13.2295 24.5 14 24.5C14.7705 24.5 15.5194 24.1187 16.1307 23.4151C16.7419 22.7116 17.1813 21.7251 17.3807 20.6088",
    stroke: "#1C1D40",
    strokeWidth: 2.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.73b1977e579de2d324adc7c99ade29c1.svg";
export { ForwardRef as ReactComponent };